(() => {
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const progress=$('[data-progress]');
  const header=$('[data-header]');
  const menuBtn=$('[data-menu-button]');
  const mobileNav=$('[data-mobile-nav]');
  const mobileBuy=$('[data-mobile-buy]');
  const onScroll=()=>{
    const max=Math.max(1,document.documentElement.scrollHeight-innerHeight);
    if(progress) progress.style.width=`${Math.min(100,(scrollY/max)*100)}%`;
    if(header) header.classList.toggle('is-fixed',scrollY>80);
    if(mobileBuy) mobileBuy.classList.toggle('is-on',scrollY>Math.min(innerHeight*.7,650));
  };
  addEventListener('scroll',onScroll,{passive:true}); onScroll();
  if(menuBtn&&mobileNav){menuBtn.addEventListener('click',()=>{const open=!mobileNav.classList.contains('is-open');mobileNav.classList.toggle('is-open',open);menuBtn.setAttribute('aria-expanded',String(open));}); $$('.dv-mobile-nav a').forEach(a=>a.addEventListener('click',()=>{mobileNav.classList.remove('is-open');menuBtn.setAttribute('aria-expanded','false');}));}
  const reveal=()=>{const els=$$('.dv-reveal'); if(!('IntersectionObserver' in window)){els.forEach(el=>el.classList.add('is-on'));return;} const io=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-on');io.unobserve(e.target);}}),{threshold:.08,rootMargin:'0px 0px -5% 0px'});els.forEach(el=>io.observe(el));}; reveal();
  $$('.dv-buy-form').forEach(form=>form.addEventListener('submit',async e=>{
    if(!window.fetch) return;
    e.preventDefault();
    const btn=$('button[type="submit"]',form); const err=$('[data-buy-error]',form); const old=btn?btn.innerHTML:'';
    const root=window.Shopify?.routes?.root || '/';
    try{
      if(btn){btn.disabled=true;btn.innerHTML='<span>ADDING…</span>';}
      const formData=new FormData(form);
      const variantId=String(formData.get('id') || '');
      const cartRes=await fetch(`${root}cart.js`,{headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}});
      const cart=await cartRes.json();
      if(!cartRes.ok) throw new Error('Unable to check your cart.');
      const alreadyInCart=cart.items?.some(item=>String(item.variant_id)===variantId);
      if(!alreadyInCart){
        const res=await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:formData});
        const data=await res.json(); if(!res.ok) throw new Error(data.description || 'Unable to add this item.');
      }
      location.href=`${root}cart`;
    }catch(ex){if(err){err.hidden=false;err.textContent=ex.message || 'Something went wrong. Please try again.';} if(btn){btn.disabled=false;btn.innerHTML=old;}}
  }));
  const singleQtyCart=$('[data-single-quantity-cart]');
  if(singleQtyCart){
    const oversized=$$('[data-cart-line]',singleQtyCart).filter(line=>Number(line.dataset.cartQuantity||1)>1);
    if(oversized.length){
      const root=window.Shopify?.routes?.root || '/';
      const updates={};
      oversized.forEach(line=>{if(line.dataset.cartVariantId) updates[line.dataset.cartVariantId]=1;});
      if(Object.keys(updates).length){
        fetch(`${root}cart/update.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({updates})
        }).then(res=>{if(!res.ok) throw new Error('Unable to normalize cart quantities.');return res.json();})
          .then(()=>location.reload())
          .catch(()=>{/* Checkout form also submits quantity=1 as a server-side fallback. */});
      }
    }
  }
})();